<template>
  <div class="layout-box">
    <LayoutHeader></LayoutHeader>
    <div class="secondary-content">
      <div class="reprint-box">
        <div class="rbox1" style="position: relative" v-loading="loading1" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">当前平稳率</h3>
          <div id="alarm11" style="width: 100%; height: 100%; padding: 40px 0 0 10px; box-sizing: border-box"></div>
        </div>
        <div class="rbox2" style="position: relative" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">工艺平稳率趋势</h3>
          <div id="alarm12" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div class="reprint-box">
        <div class="rbox2" style="width: 49.75%;position: relative" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">平稳率详细</h3>
          <div id="alarm13" style="width: 100%; height: 100%;padding: 40px 15px 0 15px;box-sizing: border-box;">
            <el-table
              :data="alarmdata1"
              height="100%"
              size="mini"
              :header-row-style="{background:'none'}"
              :header-cell-style="{background:'none',padding:'6px 0',color:'#fff','border-bottom': '1px solid #2E88FF'}"
              row-class-name="self-owned-table"
              class="nonebak"
              style="width: 100%;color: #fff; font-size: 10px">
              <el-table-column
                prop="indexName"
                label="工艺指标">
              </el-table-column>
              <el-table-column
                prop="typeNmae"
                label="指标类型">
              </el-table-column>
              <el-table-column
                prop="upValue"
                label="超上限">
              </el-table-column>
              <el-table-column
                prop="downValue"
                label="超下限">
              </el-table-column>
              <el-table-column
                prop="rate"
                label="平稳率">
              </el-table-column>
              <el-table-column
                prop="timeStr"
                label="更新时间">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="rbox1" style="width: 49.75%;position: relative" v-loading="loading4" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">平稳率对比</h3>
          <div id="alarm14" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div class="reprint-box">
        <div class="rbox2" style="position: relative" v-loading="loading5" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">能耗</h3>
          <div id="alarm15" class="alarm3" style="width: 100%; height: 100%;padding: 40px 15px 0 15px;box-sizing: border-box;">
            <div>
              <span>实际耗水_吨</span>
              <h2><countTo :startVal='0' :endVal='alarmdata5.waterConsume*1 || 0' :decimals="1" :duration='100'></countTo></h2>
            </div>
            <div>
              <span>实际耗电_度</span>
              <h2>{{alarmdata5.electricityConsume || 0}}</h2>
            </div>
            <div>
              <span>实际耗气_吨</span>
              <h2><countTo :startVal='0' :endVal='alarmdata5.gasConsume*1 || 0' :decimals="1" :duration='100'></countTo></h2>
            </div>
            <div>
              <span>年度指标_吨</span>
              <h2>{{alarmdata5.yearT || 0}}</h2>
            </div>
            <div>
              <span>年度指标_度</span>
              <h2>{{alarmdata5.yearD || 0}}</h2>
            </div>
            <div>
              <span>年度指标_吨</span>
              <h2>{{alarmdata5.yearTT || 0}}</h2>
            </div>
          </div>
        </div>
        <div class="rbox1" style="position: relative" v-loading="loading6" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">设备</h3>
          <div id="alarm16" style="width: 100%; height: 100%;padding: 40px 15px 0 15px;box-sizing: border-box;"  class="alarm3">
            <div style="width: 50%">
              <span>接入设备数量</span>
              <h2><countTo :startVal='0' :endVal='alarmdata6.deviceNum*1 || 0' :decimals="1" :duration='100'></countTo></h2>
            </div>
            <div style="width: 50%">
              <span>接入企业数量</span>
              <h2><countTo :startVal='0' :endVal='alarmdata6.enterpriseNum*1 || 0' :decimals="1" :duration='100'></countTo></h2>
            </div>
            <div>
              <span>设备开机率</span>
              <h2><countTo :startVal='0' :endVal='alarmdata6.deviceRate*1 || 0' :decimals="1" :duration='100'></countTo></h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/production-alarm-header";
import {getTime} from "../../bll/utils";
import countTo from 'vue-count-to';

export default {
  name: 'ProductionAlarmAnalysis',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader,
    countTo
  },
  data () {
    return {
      loading1:true,
      loading2:true,
      loading3:true,
      loading4:true,
      loading5:true,
      loading6:true,
      alarmdata1:[],
      alarmdata5:{},
      alarmdata6:{},
    }
  },
  mounted () {
    const $this=this
    setTimeout(function () {
      $this.getdata()
    },500)
    $this.dataRefresh.$ons('Refresh', () => {
      $this.getdata()
    })
  },
  methods:{
    getdata(){
      const $this=this
      const url = '/api-portal/stableRate/nowrate';
      $this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datall=datas.data.rateValue
          $this.alarmgaugechart(datall)
          $this.loading1=false
        }
      })
      const url2 = '/api-portal/stableRate/craftrate';
      $this.$api.post(url2, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datall=datas.data
          let time=datall.dataX
          let series=[]
          const colors=['#4CA2DC','#6D6DF2','#1FD3CD','#FE8433','#2E88FF']
          datall.dataY.forEach(val=>{
            const col=colors[val.nameStr*1-1]
            const zj={
              name: val.nameStr,
              type: 'line',
              smooth: true,
              showSymbol: false,
              color: col,
              data:val.dataList
            }
            series.push(zj)
          })
          $this.alarmbarchart(series,time)
          this.loading2=false
        }
      })
      const url3 = '/api-portal/stableRate/rateDetail';
      $this.$api.post(url3, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.alarmdata1=datas.data
          $this.loading3=false
        }
      })
      const url4 = '/api-portal/stableRate/contrast';
      $this.$api.post(url4, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datall=datas.data
          let time=datall.dataX
          let series=[]
          const colors=['#4CA2DC','#6D6DF2','#1FD3CD','#FE8433','#2E88FF']
          datall.dataY.forEach(val=>{
            const col=colors[val.typeName*1-1]
            const zj={
              name: val.typeName,
              type: 'bar',
              smooth: true,
              color: col,
              showSymbol: false,
              data:val.list
            }
            series.push(zj)
          })
          $this.Loadtrendline(series,time,'alarm14')
          this.loading4=false
        }
      })
      const url5 = '/api-portal/stableRate/energyConsumption';
      $this.$api.post(url5, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.alarmdata5=datas.data
          $this.loading5=false
        }
      })
      const url6 = '/api-portal/stableRate/device';
      $this.$api.post(url6, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.alarmdata6=datas.data
          $this.loading6=false
        }
      })
    },
    Loadtrendline(datall,t,obj){
      const myEchartst = this.$echarts.init(document.getElementById(obj))
      var st = t[t.length -29]
      var ed = t[t.length -1]
      let option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: true,
          left: 'center',
          top: 20,
          icon:'path://M128 432h768v192H128z',
          textStyle: {
            color: '#AAAAB0'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '12%',
          top: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#B6B6BB',
            // formatter: function (params) {
            //   return parseTime(params,'{y}-{m}-{d}')
            // }
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data:t
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show:false,
          },
          max:function (value) {
            return parseInt((value.max+9)/10)*10
          },
          min:function (value) {
            return parseInt((value.min-2)/10)*10
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#555656'
            }
          },
          axisLabel: {
            color: '#B6B6BB',
            formatter: function (params) {
              let name=params
              if(params>1000){
                name=parseInt((params+500)/1000)+'千'
              }
              if(params>10000){
                name=parseInt((params+5000)/10000)+'万'
              }
              return name
            }
          }
        },
        dataZoom: [
          {
            type: 'slider',
            borderColor:'#000',
            backgroundColor: 'rgba(47,69,84,0.8)',
            startValue: st,
            endValue: ed
          }
        ],
        series: datall
      }
      myEchartst.setOption(option)
    },
    alarmbarchart (datall,t) {
      const myEchartst = this.$echarts.init(document.getElementById('alarm12'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: true,
          left: 'center',
          top: 20,
          icon:'path://M128 432h768v192H128z',
          textStyle: {
            color: '#AAAAB0'
          }
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '21%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: t
        },
        yAxis: {
          type: 'value',
          splitLine: {show:false},
          max:function (value) {
            return parseInt((value.max+9)/10)*10
          },
          min:function (value) {
            return parseInt((value.min-2)/10)*10
          },
          axisLabel: {
            color: '#C1D3F4'
          }
        },
        series: datall
      }
      myEchartst.setOption(option)
    },
    alarmgaugechart (num) {
      const myEchartst = this.$echarts.init(document.getElementById('alarm11'))
      let arr=[]
      arr.push(num)
      let option = {
        title: [
          {
            text: '{val|' + num.toFixed(1) + '%}\n{name|' + '平稳率' + '}',
            bottom: 'center',
            left: 'center',
            zlevel: 100,
            textStyle: {
              rich: {
                val: {
                  fontSize: 21,
                  color: '#E5E5E5',
                  fontFamily: 'DIN-Bold',
                  padding: [2, 0],
                },
                name: {
                  fontSize: 12,
                  color: '#fff',
                },
              },
            },
            triggerEvent: true,
          },
          {
            text: '{name|' + '实际:'+ num + '}',
            bottom: '12%',
            left: 'center',
            zlevel: 100,
            textStyle: {
              rich: {
                val: {
                  fontSize: 18,
                  color: '#E5E5E5',
                  fontFamily: 'HYYakuHei',
                  padding: [5, 0]
                },
                name: {
                  fontSize: 14,
                  color: '#9B9BA1',
                },
              },
            },
            triggerEvent: true,
          },
        ],
        series: [
          {
            name: '刻度尺',
            type: 'gauge',
            radius: '100%',
            splitNumber: 8, // 刻度数量
            min: 0, // 最小刻度
            max: 100,
            // 仪表盘轴线相关配置
            axisLine: {
              lineStyle: {
                color: [
                  [
                    5,
                    {
                      type: 'radial',
                      x: 0.5,
                      y: 0.6,
                      r: 0.6,
                      colorStops: [
                        {
                          offset: 0.85,
                          color: 'rgba(50, 226, 247, 0)', // 0% 处的颜色
                        },
                        {
                          offset: 0.90,
                          color: 'rgba(24, 124, 165, 0.1)', // 100% 处的颜色
                        },
                        {
                          offset: 1,
                          color: 'rgba(24, 124, 165, 1.00)', // 100% 处的颜色
                        },
                      ],
                    },
                  ],
                ],
                width: 200,
              },
            },
            /** 分隔线样式*/
            splitLine: {
              show: true,
              length: 9,
              lineStyle: {
                width: 1,
                color: '#fff', // 用颜色渐变函数不起作用
              },
            },
            /** 刻度线*/
            axisTick: {
              show: true,
              splitNumber: 2,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)', // 用颜色渐变函数不起作用
                width: 1,
              },
              length: 5,
            },
            /** 刻度标签*/
            axisLabel: {
              distance: 2,
              color: 'rgba(255, 255, 255, 1)',
              fontSize: 12,
              fontFamily: 'DIN-Bold'
            },
            detail: {
              show: false,
            },
            animationDuration: 1000,
          },
          {
            name: '第二次弧形向外渐变',
            type: 'gauge',
            radius: '55%',
            splitNumber: 0, // 刻度数量
            min: 0, // 最小刻度
            max: 100,
            // 仪表盘轴线相关配置
            axisLine: {
              lineStyle: {
                color: [
                  [
                    3,
                    {
                      type: 'radial',
                      x: 0.5,
                      y: 0.6,
                      r: 0.6,
                      colorStops: [
                        {
                          offset: 0.84,
                          color: 'rgba(50, 226, 247, 0)', // 0% 处的颜色
                        }, {
                          offset: 0.85,
                          color: 'rgba(29, 129, 172, 1.00)', // 0% 处的颜色
                        },
                        {
                          offset: 0.99,
                          color: 'rgba(24, 124, 165, 0.1)', // 100% 处的颜色
                        },
                        {
                          offset: 1,
                          color: 'rgba(50, 226, 247, 0)', // 100% 处的颜色
                        },
                      ],
                    },
                  ],
                ],
                width: 200,
              },
            },
            /** 分隔线样式*/
            splitLine: {
              show: false,
              length: 9,
              lineStyle: {
                width: 1,
                color: '#fff', // 用颜色渐变函数不起作用
              },
            },
            /** 刻度线*/
            axisTick: {
              show: false,
              splitNumber: 2,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)', // 用颜色渐变函数不起作用
                width: 1,
              },
              length: 5,
            },
            /** 刻度标签*/
            axisLabel: {
              distance: 2,
              show: false,
              color: 'rgba(255, 255, 255, 1)',
              fontSize: 12,
              fontFamily: 'DIN-Bold'
            },
            detail: {
              show: false,
            },
            animationDuration: 1000,
          },
          {
            name: "指针",
            type: "gauge",
            zlevel: 5,
            radius: "70%",
            startAngle: 215,
            endAngle: -40,
            center: ["50%", "55%"], //整体的位置设置
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            min: 0,
            max: 100,
            pointer: {
              show: true,
              width: 3,
              length: "110%",
              offsetCenter: [0, 0],
            },
            itemStyle: {
              normal: {
                color: '#fff'
              }
            },
            detail: {
              show: false,

            },
            data: [num]
          },
          {
            name: '渐变进度',
            type: 'gauge',
            radius: '100%',
            splitNumber: 0,
            startAngle: 225,
            endAngle: -45,
            zlevel: 9,
            axisLine: {
              lineStyle: {
                color: [
                  [
                    num / 100,
                    {
                      type: 'linear',
                      x: 0,
                      y: 1,
                      x2: 0,
                      y2: 0,
                      colorStops: [
                        {
                          offset: 0,
                          color: 'rgba(60,207,223,0)', // 0% 处的颜色
                        },
                        {
                          offset: 0.9,
                          color: 'rgba(46, 136, 255, 0.8)', // 100% 处的颜色
                        },
                        {
                          offset: 1,
                          color: 'rgba(46, 136, 255, 1)', // 100% 处的颜色
                        },
                      ],
                    },
                  ],
                ],
                width: 60,
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            itemStyle: {
              show: false,
            },
            detail: {
              show: false,
            },
            title: {
              // 标题
              show: false,
            },
            data: [],
            pointer: {
              show: false,
            },
            animationDuration: 1000,
          },
          {
            type: 'pie',
            radius: ['0', '38%'],
            center: ['50%', '50%'],
            hoverAnimation: false,
            z: 3,
            data: [
              {
                value: 100,
                itemStyle: {
                  normal: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: 'rgba(11, 46, 123, 1.00)',
                      },
                      {
                        offset: 1,
                        color: 'rgba(6, 97, 191, 1.00)',
                      },
                    ]),
                    opacity: 1,
                  },
                },
                label: {
                  show: false,
                },
              },
            ],
            labelLine: {
              show: false,
            },
          },
          {
            type: 'pie',
            radius: ['0', '30%'],
            center: ['50%', '50%'],
            hoverAnimation: false,
            zlevel: 8,
            data: [
              {
                value: 100,
                itemStyle: {
                  normal: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: 'rgba(11, 46, 123, 1.00)',
                      },
                      {
                        offset: 1,
                        color: 'rgba(6, 97, 191, 1.00)',
                      },
                    ]),
                    opacity: 1,
                  },
                },
                label: {
                  show: false,
                },
              },
            ],
            labelLine: {
              show: false,
            },
          }

        ]
      }
      myEchartst.setOption(option)
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  top:0;
  left: 0;
  background: #060614 url("../../assets/bjs.png") no-repeat top/100%;
}

.secondary-content{
  width: 100%;
  height: calc(100% - 20px);
  padding: 0 10px;
  padding-top: 132px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  flex-direction:column;
  color: #fff;
}

.reprint-box{
  box-sizing: border-box;
  height: 32.7%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reprint-box>div{
  border: 1px solid #374E7F;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.rbox1{
  width: 30.5%;
}
.rbox2{
  width: 69%;
}

.el-table, .el-table__expanded-cell{
  background: none;
}

.nonebak:before{
  background: none;
}

.alarm3{
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap:wrap;
  justify-content:center
}

.alarm3>div{
  width: 33.3%;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.alarm3>div>span{
  font-size: 12px;
  color: #aDaDa4;
}

.alarm3>div h2{
  margin-top: 10px;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/secondary/production-alarm-analysis.vue